/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Itemsdescription1Inputs */

const id_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item katalog yang dapat dimiliki yang terkandung dalam penawaran. Ini adalah catatan yang menjadi hak pemain setelah pembelian atau penukaran.`)
};

const ms_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item katalog boleh milik yang terkandung dalam tawaran. Ini adalah rekod yang menjadi hak pemain selepas pembelian atau penebusan.`)
};

const da_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejbare katalog-items indeholdt i tilbud. Disse er posterne der bliver til spillerrettigheder efter et køb eller indløsning.`)
};

const de_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besitzbare Katalog-Items, die in Angeboten enthalten sind. Dies sind die Datensätze, die nach einem Kauf oder einer Einlösung zu Spielerberechtigungen werden.`)
};

const en_us2_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownable catalog items contained by offers. These are the records that become player entitlements after a purchase or redemption.`)
};

const es_es2_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems de catálogo de propiedad contenidos en ofertas de catálogo. Estos son los registros que se convierten en derechos de jugador después de una compra o canje.`)
};

const es_mx2_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems de catálogo que pueden ser propiedad, contenidos en ofertas. Estos son los registros que se convierten en derechos del jugador después de una compra o canje.`)
};

const fil_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga item sa catalog na maaaring pag-aari na nakapaloob sa mga offer. Ito ang mga talaan na nagiging entitlement ng manlalaro pagkatapos ng pagbili o pag-redeem.`)
};

const fr_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items de catalogue propriétaires contenus dans les offres. Ce sont les enregistrements qui deviennent des droits du joueur après un achat ou un échange.`)
};

const it_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli del catalogo possedibili contenuti nelle offerte. Questi sono i registri che diventano diritti del giocatore dopo un acquisto o riscatto.`)
};

const hu_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok által tartalmazott tulajdonolható katalóguselemek. Ezek a rekordok válnak játékos jogosultságokká vásárlás vagy beváltás után.`)
};

const nl_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigendomsbare catalogusitems in aanbiedingen. Dit zijn de records die spelersrechten worden na een aankoop of inwisseling.`)
};

const no_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eierbare katalogelementer inneholdt i tilbud. Dette er postene som blir spillerrettigheter etter et kjøp eller innløsning.`)
};

const pl_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy katalogu z możliwością posiadania, zawarte w ofertach. Są to rekordy, które stają się uprawnieniami gracza po zakupie lub aktywacji.`)
};

const pt_br2_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens de catálogo de propriedade contidos em ofertas de catálogo. Estes são os registros que se tornam direitos do jogador após uma compra ou resgate.`)
};

const pt_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens de catálogo com direitos de propriedade contidos em ofertas. Estes são os registos que se tornam direitos do jogador após uma compra ou resgate.`)
};

const ro_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente de catalog care pot fi deținute, conținute în oferte. Acestea sunt înregistrările care devin drepturi ale jucătorului după o achiziție sau răscumpărare.`)
};

const fi_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omistettavat katalogikohteet, jotka sisältyvät tarjouksiin. Nämä ovat tietueita, joista tulee pelaajan oikeuksia oston tai lunastuksen jälkeen.`)
};

const sv_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ägarbara katalogobjekt som ingår i erbjudanden. Dessa är posterna som blir spelarens rättigheter efter ett köp eller inlösen.`)
};

const vi_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các mục danh mục có thể sở hữu được chứa trong ưu đãi. Đây là các hồ sơ trở thành quyền của người chơi sau khi mua hoặc đổi.`)
};

const tr_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler tarafından içerilen sahip olunabilir katalog öğeleri. Bunlar, bir satın alma veya kullanım sonrasında oyuncu haklarına dönüşen kayıtlardır.`)
};

const cs_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnitelné katalogové položky obsažené v nabídkách. To jsou záznamy, které se po nákupu nebo uplatnění stanou právy hráče.`)
};

const bg_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти на каталог, които могат да се притежават, съдържащи се в офертите. Това са записите, които стават права на играча след покупка или осребряване.`)
};

const ru_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объекты каталога, которыми можно владеть, содержащиеся в предложениях. Это записи, которые становятся правами игрока после покупки или активации.`)
};

const uk_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементи каталогу, які можна придбати через пропозиції. Це записи, які стають правами гравця після покупки або активації.`)
};

const ar_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عناصر الكتالوج القابلة للامتلاك الموجودة في العروض. هذه هي السجلات التي تصبح حقوقًا للاعب بعد الشراء أو الاستلام.`)
};

const hi_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र में निहित स्वामित्व योग्य कैटलॉग आइटम। ये वे रिकॉर्ड हैं जो खरीद या रिडीम के बाद खिलाड़ी के अधिकार बन जाते हैं।`)
};

const th_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการแค็ตตาล็อกที่สามารถเป็นเจ้าของได้ซึ่งบรรจุอยู่ในข้อเสนอ เหล่านี้คือบันทึกที่กลายเป็นสิทธิ์ของผู้เล่นหลังจากการซื้อหรือการรับ`)
};

const ja_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーに含まれる所有可能なカタログアイテム。これらは購入または引き換え後にプレイヤーの権利となるレコードです。`)
};

const zh_cn2_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含在目录项中的可拥有目录物品。这些是玩家在购买或兑换后获得授权的记录。`)
};

const zh_hant1_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含在目錄項目中的可擁有目錄物品。這些是玩家在購買或兌換後獲得授權的記錄。`)
};

const ko_sandboxes_itemsdescription1 = /** @type {(inputs: Sandboxes_Itemsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼에 포함된 소유 가능한 카탈로그 아이템입니다. 구매 또는 교환 후 플레이어 권한이 되는 레코드입니다.`)
};

/**
* | output |
* | --- |
* | "Ownable catalog items contained by offers. These are the records that become player entitlements after a purchase or redemption." |
*
* @param {Sandboxes_Itemsdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_itemsdescription1 = /** @type {((inputs?: Sandboxes_Itemsdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Itemsdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_itemsdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_itemsdescription1(inputs)
	if (locale === "da") return da_sandboxes_itemsdescription1(inputs)
	if (locale === "de") return de_sandboxes_itemsdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_itemsdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_itemsdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_itemsdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_itemsdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_itemsdescription1(inputs)
	if (locale === "it") return it_sandboxes_itemsdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_itemsdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_itemsdescription1(inputs)
	if (locale === "no") return no_sandboxes_itemsdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_itemsdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_itemsdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_itemsdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_itemsdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_itemsdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_itemsdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_itemsdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_itemsdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_itemsdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_itemsdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_itemsdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_itemsdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_itemsdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_itemsdescription1(inputs)
	if (locale === "th") return th_sandboxes_itemsdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_itemsdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_itemsdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_itemsdescription1(inputs)
	return ko_sandboxes_itemsdescription1(inputs)
});
export { sandboxes_itemsdescription1 as "sandboxes.itemsDescription" }